import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';


import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import ShowValue from '../../components/ShowValue';
import MessageModal from '../Message';
import AuthService from '../../utils/auth.service';

class Navbar extends Component {
	
  authService = AuthService;

  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      
      currentUser: null,
      profile: null,  // Is this user anywhere?
      
      emailMessage: '',
      messageModal: {
        open: false,
        title: '',
        message: ''
      }
    };

    document.addEventListener('messageModal', data => {
      if (data.detail) {
        let message = data.detail;
        message.open = true;
        this.setState(...this.state, { messageModal: message });
      }
    });

    document.addEventListener('firebaseLogin', data => {
      if (data.detail) {
        this.setState(...this.state, {
        	currentUser: data.detail.registerData
        });
      }
    });

    document.addEventListener('profileLoaded', (data) => {
      if (data.detail) {
        this.setState(...this.state, {
          currentUser: data.detail.registerData,
          profile: data.detail.profile,
          emailMessage: `mailto:rc@winvite.io?subject=Oi! Meu nome : ${data.detail.profile.name}, Gostaria de entrar em contato...&body=Time da Winvite.io, %0D`
        });
      }
    });

    document.addEventListener('profileLogout', (data) => {
      if (data.detail) {
        this.setState(...this.state, {
          currentUser: data.detail.registerData,
          profile: data.detail.profile
        });
      }
    });

    // Not Converted to arrow functions...
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.reload_winvite = this.reload_winvite.bind(this);
    this.replace_winvite = this.replace_winvite.bind(this);
    this.change_language = this.change_language.bind(this);
    
    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState(...this.state, { dropdownOpen: !this.state.dropdownOpen });
  }

  toggleMessageModal() {
    this.setState(...this.state, { messageModal: { open: !this.state.messageModal.open } });
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }
  
  replace_winvite() {
  	console.log('Replace clicked...')
	  
	  window.location.replace("/")
	  
  }
  
  reload_winvite() {
  	console.log('Reload clicked...');
	  
	  window.location.reload();
	  
  }
  
  change_language() {
	  
  	const { i18n } = this.props;
  	
  	if (i18n.languages[0] === 'pt') {
  		i18n.changeLanguage('en')
	  } else {
  		i18n.changeLanguage('pt')
	  }
  	
  	console.log(i18n.languages[0]);
	  
  }
	

  render() {
  	
  	const { i18n } = this.props;
  	
    return (
      <nav className="navbar bg-dark nopadding">
        <div className="container nopadding">
	        
	        
          <button className="btn" onClick={this.replace_winvite}>
            
              <img src="/assets/images/winvite_logo.png" width="68" height="25" alt="." />
            
          </button> {/* Winvite to Main */}
          
          <button className="btn" width="20" height="20"
                  onClick={this.change_language}>
	          <img src={i18n.languages[0] === 'pt' ? "/assets/images/us.svg" : "/assets/images/br.svg"}
	                width={i18n.languages[0] === 'pt' ? "20" : "20"}
	                height="20"
	               alt="languages"/>
          </button>

          <ul className="navbar-nav ml-auto">
            <li className="nav-item"
                hidden={this.state.currentUser && this.state.profile}>
              <button className="nav-link google-login"
                      onClick={this.login}>
                <img className="google-img" width="20" alt="Logo Google" src="/assets/images/logo-google.png" />
                <span className="google-text">
	                Log in
                </span>
              </button>
            </li> {/* Login button */}

            <li className="nav-item">
              <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}
                        hidden={!this.state.currentUser || !this.state.profile}>

                <DropdownToggle caret>
                  <img className="profile-picture" src={this.state.currentUser ? this.state.currentUser.photoURL : null} alt="personal" />
                  {this.state.profile ? this.state.profile.name.substring(0,12) : 'Error User'}
                    {/*<span className="profile-btc" hidden={this.state.profile.btc_founds === undefined || this.state.profile.btc_founds !== this.state.profile.btc_balance}>*/}
                  <span className="profile-btc" >
                    <ShowValue withoutBreak="true" btc={this.state.profile ? this.state.profile.btc_balance ? this.state.profile.btc_balance : 0 : 0} />
                  </span> {/* Net Balance */}
                    {/*<span className="profile-btc" hidden={this.state.profile.btc_founds !== undefined}> Loading... </span> Loading */}
                    {/*<span className="profile-btc" hidden={this.state.profile.btc_founds === this.state.profile.btc_balance}> Waiting for Blockchain... </span> Waiting */}
                </DropdownToggle>

                <DropdownMenu>

                  <DropdownItem>
                    <Link to="/profile">
                      <i className="far fa-user mr-2"></i> Profile
                    </Link>
                  </DropdownItem> {/* Profile */}

                  <DropdownItem>
                    <Link to="/profile/wallet">
                      <i className="fab fa-bitcoin mr-2"></i> Wallet
                    </Link>
                  </DropdownItem> {/* Wallet */}

                  <DropdownItem>

                    <a href={this.state.emailMessage ? this.state.emailMessage : ''}>
                      <i className="fas fa-question mr-2"></i>Email ...
                    </a>
                  </DropdownItem> { /* Help */}

                  <DropdownItem className="dropdown-item-custom" onClick={this.logout}>
                    <i className="fas fa-sign-out-alt mr-2"></i>
                    Logout
                   </DropdownItem> {/* Logout */}
                </DropdownMenu>

              </Dropdown>
            </li> {/* Dropdown */}
          </ul>
	        
        </div>
	      
        <MessageModal message={this.state.messageModal.message}
                      title={this.state.messageModal.title}
                      toggle={this.toggleMessageModal}
                      isOpen={this.state.messageModal.open} />
      </nav>
    );
  }
}

export default withTranslation()(Navbar);


// WEBPACK FOOTER //
// ./src/components/Main/navbar.js